module.exports = __webpack_public_path__ + "ci_vendor_consul.db355.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/ci_vendor_consul.svg
// module id = ./src/_asset/sources/assets/images/@svg/ci_vendor_consul.svg
// module chunks = main